export default {"src":"/_next/static/media/credit.a68e035a.svg","height":37,"width":46};